import React from "react";
import { Box, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import IndustryCard from "./industryCard/IndustryCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Aerospace_Defence from '../../../../assets/images/home/industry_images/Aerospace and Defense.jpg'
import Automotive_Transport from '../../../../assets/images/home/industry_images/Automotive And Transport.jpg'
import BFSI from '../../../../assets/images/home/industry_images/BFSI.jpg'
import ConstructionManufacturing from '../../../../assets/images/home/industry_images/Construction Manufacturing.jpg'
import ConsumerGoods from '../../../../assets/images/home/industry_images/Consumer Good.jpg'
import Energy_Power from '../../../../assets/images/home/industry_images/Energy And Power.jpg'
import Food_Beverages from '../../../../assets/images/home/industry_images/Food And Bevrages.jpg'
import ICT_Media from '../../../../assets/images/home/industry_images/ICT And Media.jpg'
import LifeSciences from '../../../../assets/images/home/industry_images/Life Sciences.jpg'
import Materials_Chemicals from '../../../../assets/images/home/industry_images/Materials and Chemicals.jpg'
import Semiconductor_Electronics from '../../../../assets/images/home/industry_images/Semiconductor and electronics.jpg'



const MainBox = styled(Box)(({theme}) => ({
  width: "35%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
  gap: 0,
  [theme.breakpoints.down('mdlg')]: {
    // gap: '1.5rem',
    width: '90%',
  }
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: '1.8rem',
  marginTop: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  }
}))


function IndustrySection() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
  const isTablet = useMediaQuery(theme.breakpoints.down('mdlg')); // Mobile screen check
  
  const IndustryDetails = [
    {
      CardImg: Aerospace_Defence,
      Title: "Aerospace and Defense",
      Info: "Analyzes aircraft, space tech, and defense systems. Includes geopolitical trends and innovation in propulsion.",
    },
    {
      CardImg: Automotive_Transport,
      Title: "Automotive and Transportation",
      Info: "Tracks EVs, autonomous tech, and mobility services. Evaluates trends in logistics, components, and regulations.",
    },
    {
      CardImg: BFSI,
      Title: "BFSI",
      Info: "Covers banking, fintech, and insurance innovations. Focuses on digital transformation, risk, and compliance.",
    },
    {
      CardImg: ConstructionManufacturing,
      Title: "Construction and Manufacturing",
      Info: "Insights into infrastructure, smart factories, and robotics. Evaluates materials, labor trends, and automation.",
    },
    {
      CardImg: ConsumerGoods,
      Title: "Consumer Goods",
      Info: "Analyzes trends in personal care, home goods, and FMCG. Includes brand strategies and shifting consumer behaviors.",
    },
    {
      CardImg: Energy_Power,
      Title: "Energy and Power",
      Info: "Focuses on renewable energy, fossil fuels, and grid systems. Tracks transition trends and sustainability goals.",
    },
    {
      CardImg: Food_Beverages,
      Title: "Food and Beverages",
      Info: "Covers packaged food, beverages, and nutrition. Analyzes consumer preferences, health trends, and supply chain.",
    },
    {
      CardImg: ICT_Media,
      Title: "ICT & Media",
      Info: "Explores telecom, cloud, and digital media trends. Covers AI, cybersecurity, content, and connectivity shifts.",
    },
    {
      CardImg: LifeSciences,
      Title: "Life Sciences",
      Info: "Covers pharmaceuticals, biotechnology, and diagnostics. Focuses on innovations, R&D trends, and regulatory impacts.",
    },
    {
      CardImg: Materials_Chemicals,
      Title: "Material and Chemicals",
      Info: "Explores industrial chemicals, polymers, and nanomaterials. Tracks innovations, regulations, and sustainability shifts.",
    },
    {
      CardImg: Semiconductor_Electronics,
      Title: "Semiconductor and Electronics",
      Info: "Covers chips, circuits, and consumer electronics. Analyzes demand, innovation, and supply chain dynamics.",
    },
  ];

  const settings = {
    dots: false, // Show navigation dots
    arrows: false, // hide nex/previous slide arrow buttons
    infinite: true, // Infinite loop scrolling
    speed: 2500, // Transition speed
    slidesToShow: 1, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    // autoplay: true, // Auto-slide enabled
    autoplaySpeed: 5000, // 5 seconds per slide
    rows: isMobile ? 1 : isTablet ? 2 : 3, // Number of rows per slide
    slidesPerRow: isMobile ? 1 : isTablet ? 3 : 2, // Number of items per row
  };

  return (
    <MainBox>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 1,
        }}
      >
        <StyledTypography
          fontWeight={600}
        >
          INDUSTRIES
        </StyledTypography>
      </Box>
      <Box>
        <Slider {...settings}>
          {IndustryDetails.map((item, index) => (
            <Box
              sx={{
                display: "flex",
                gridTemplateColumns: "auto auto",
                placeItems: "center",
              }}
            >
              <IndustryCard key={index} {...item} />
            </Box>
          ))}
        </Slider>
      </Box>
    </MainBox>
  );
}

export default IndustrySection;
